import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { FolderDataService } from '../../../dave-data-module/services/folder-data.service';
import { FolderTypes } from '../../../dave-data-module/entities/folder.entity';
import { map, shareReplay } from 'rxjs/operators';


export interface MaterialMainDataPopupComponentDialogData {
    MaterialId: number;
}
@Component({
  selector: 'app-material-main-data-popup',
  templateUrl: './material-main-data-popup.component.html',
  styleUrls: ['./material-main-data-popup.component.scss']
})
export class MaterialMainDataPopupComponent {

    public static DefaultConfig: MatDialogConfig = {
        maxWidth: '100vw',
        hasBackdrop: false,
        closeOnNavigation: true,
        panelClass: 'custom-dialog-class-for-overlay-on-right-side',
    };
    public Editing = false;
    public FolderId$: Observable<number>;
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public Dialogdata: MaterialMainDataPopupComponentDialogData,
        folderDataService: FolderDataService,
    ) {
        this.FolderId$ = folderDataService.getFolderFromEntity(Dialogdata.MaterialId, FolderTypes.resource).pipe(
            map((folders) => folders?.Id),
            shareReplay({bufferSize: 1, refCount: true}),
        );
    }

}
